import $ from 'jquery';
import Base from '../../../_config/base';

class Video extends Base {
  constructor(el) {
    super(el);

    this.self = this;

    self.$video = $(this.$el.find('video'));
    self.$controls = $(this.$el.find('.video__controls'));
    self.$playButton = $(this.$el.find('.video__play'));
    self.$pauseButton = $(this.$el.find('.video__pause'));

    self.$video.on('mousemove', this.showControls.bind());

    self.$video.on('ended', () => {
      self.$playButton.removeClass('hidden');
      self.$pauseButton.addClass('hidden');
      self.$controls.removeClass('playing');
    });

    self.$playButton.on('click', this.playVideo.bind(this));

    self.$pauseButton.on('click', this.pauseVideo.bind(this));

    setTimeout(this.hideControls, 3000);
  }

  playVideo(e) {
    const $root = $(e.target).closest('.video');
    const $video = $root.find('video');
    const $playButton = $root.find('.video__play');
    const $pauseButton = $root.find('.video__pause');
    const $controls = $root.find('.video__controls');
    $playButton.addClass('hidden');
    $pauseButton.removeClass('hidden');
    $controls.addClass('playing');
    $video.get(0).play();
  }

  pauseVideo(e) {
    const $root = $(e.target).closest('.video');
    const $video = $root.find('video');
    const $playButton = $root.find('.video__play');
    const $pauseButton = $root.find('.video__pause');
    $pauseButton.addClass('hidden');
    $playButton.removeClass('hidden');
    $video.get(0).pause();
  }

  showControls() {
    self.$controls.removeClass('hidden');
  }

  hideControls() {
    self.$controls.addClass('hidden');
  }
}

Video.className = 'Video';
export default Video;



// WEBPACK FOOTER //
// ./src/materials/molecules/video/video.js